import { ButtonLink, RiArrowRightSLine, Stack, StackProps } from 'component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ChartHeading, ChartHeadingProps } from '@/components/Charts/components/ChartHeading';

export const LandMonitoringCard = ({
  'data-testid': dataTestId,
  title,
  heading,
  stats,
  image,
  detailsPagePath,
  ...delegated
}: Omit<StackProps, 'title'> & {
  title: React.ReactNode;
  heading: ChartHeadingProps;
  stats: React.ReactNode;
  image: { url: string; alt: string };
  detailsPagePath: string;
}) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <Stack spacing={8} className='flex-1 rounded-[32px] bg-white-100 p-8' data-testid={dataTestId} {...delegated}>
      <span className='typography-h3'>{title}</span>
      <Stack spacing={6} className='rounded-2xl bg-bg-light-grey p-6'>
        <ChartHeading {...heading} />
        <Stack spacing={6} centerMain className='flex-col-reverse justify-between md:flex-row min-h-[265px]'>
          {stats}

          <img
            data-testid={`${dataTestId}-image`}
            src={image.url}
            className='max-h-[265px] min-w-0 max-w-full'
            alt={image.alt}
          />
        </Stack>

        <Stack spacing={4}>
          <ButtonLink
            to={detailsPagePath}
            state={{ from: pathname }}
            variant='outline'
            rightAdornment={<RiArrowRightSLine size={20} />}
            className='self-start'
          >
            {t('shared.ncaDetail.details.ecologicalIntegrity.labels.seeMoreDetails')}
          </ButtonLink>
        </Stack>
      </Stack>
    </Stack>
  );
};
